import axios, { AxiosError } from 'axios';

import { ApiError } from './types';

export const handleApiError = (error: unknown): Error => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ApiError>;
    if (axiosError.response) {
      const errorData = axiosError.response.data;
      let errorMessage = 'Ошибка сервера';

      if (errorData) {
        if (errorData.err) {
          errorMessage = errorData.err;
        } else if (typeof errorData.data === 'string') {
          errorMessage = errorData.data;
        } else if (typeof errorData === 'string') {
          errorMessage = errorData;
        }
      }

      const statusCode = axiosError.response.status;
      if (statusCode === 400) {
        errorMessage = `Некорректный запрос: ${errorMessage}`;
      } else if (statusCode === 401) {
        errorMessage = `Не авторизован: ${errorMessage}`;
      } else if (statusCode === 408) {
        errorMessage = `Таймаут запроса: ${errorMessage}`;
      } else if (statusCode >= 500) {
        errorMessage = `Ошибка сервера: ${errorMessage}`;
      }

      return new Error(errorMessage);
    } else if (axiosError.request) {
      return new Error('Нет ответа от сервера');
    }
  }
  return error instanceof Error ? error : new Error('Неизвестная ошибка');
};
